import * as React from 'react';
import { cn } from '../utils/cn';

export interface EmptyProps {
  /** Description text */
  description?: React.ReactNode;
  /** Custom image/icon */
  image?: React.ReactNode;
  /** Additional class names */
  className?: string;
  /** Inline style */
  style?: React.CSSProperties;
  /** Extra content below description */
  children?: React.ReactNode;
}

export function Empty({
  description = 'Ingen data',
  image,
  className,
  style,
  children,
}: EmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-4 text-center',
        className
      )}
      style={style}
    >
      {image || (
        <svg
          className="mb-4 text-gray-300"
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      )}
      {description && (
        <p className="text-sm text-muted-foreground font-body">{description}</p>
      )}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
}
